// @flow
import * as React from "react";
import styled, { css } from "styled-components";
import { Link as _Link } from "../common/Link";
import { fontSize } from "../common/styled-mixins";

const Button = styled.button`
  direction: ${({ theme }) => theme.direction};
  display: inline-block;
  min-width: 130px;
  min-height: 33px;
  box-sizing: border-box;
  font-weight: 700;
  font-size: ${fontSize(14)};
  line-height: 1;
  text-align: center;
  color: #fff;
  background-color: #877c95;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  ${({ theme }) =>
    theme.locale !== "ar" &&
    css`
      :first-letter {
        text-transform: uppercase;
      }
    `};

  :hover,
  :focus,
  :active {
    background-color: #706281;
    outline: none;
  }

  ${process.env.REACT_APP_DEPLOY_TARGET === "irontrade" &&
    css`
      position: relative;
      font-weight: bold;
      color: #ffffff;
      text-decoration: none;
      background-image: linear-gradient(to left, #47c0c8 0%, #5c6cc0 100%);
      border-radius: 32px;
      cursor: pointer;
      z-index: 2;

      ::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: block;
        background-image: linear-gradient(to left, #5c6cc0 0%, #47c0c8 100%);
        border-radius: inherit;
        z-index: -1;
        opacity: 0;
        transition: opacity 0.5s;
      }

      :hover {
        color: #ffffff;
        ::before {
          opacity: 1;
        }
      }
    `};

  ${({ type }) =>
    type === "trade" &&
    !process.env.REACT_APP_DEPLOY_TARGET === "irontrade" &&
    css`
      color: #ffffff;
      background-color: ${({ theme }) => theme.accent};

      :hover,
      :focus,
      :active {
        color: #362f41;
        background-color: #e48900;
      }
    `};

  ${({ type }) =>
    type === "deposit" &&
    !process.env.REACT_APP_DEPLOY_TARGET === "irontrade" &&
    css`
      background-color: #60a31c;

      :hover,
      :focus,
      :active {
        background-color: #477f14;
      }
    `};

  ${({ isCardButton }) =>
    isCardButton &&
  process.env.REACT_APP_DEPLOY_TARGET === "irontrade" &&
    css`
      color: #ffffff;
      background: transparent;
      border: 2px solid #ffffff;
      border-radius: 20px;

      :hover,
      :focus,
      :active {
        color: #3b9478;
        background: #ffffff;

        ::before {
          display: none;
        }
      }
    `};

  ${({ disabled }) =>
    disabled &&
    css`
      color: #fff;
      background-color: #97959a;
      pointer-events: none;
      user-select: none;
      cursor: default;

      :hover {
        color: #fff;
        background-color: #97959a;
      }

      ${process.env.REACT_APP_DEPLOY_TARGET === "irontrade" &&
        css`
          color: #fff;
          background-color: #47c0c8;
          background-image: linear-gradient(to left, #47c0c8 0%, #5c6cc0 100%);
          border-radius: 32px;
          opacity: 0.59;
        `};
    `};

  ${({ invited }) =>
    invited &&
    css`
      background: #0085eb !important;

      :before {
        display: none;
      }

      :after {
        display: none;
      }
    `};

  ${({ isTradePageCard }) =>
    isTradePageCard &&
    css`
      min-width: 0;
      width: auto;
      padding: 12px 18px;
      font-size: ${fontSize(12)};
      font-weight: bold;
      text-transform: uppercase;
      background: none;
      border: 2px solid #ffffff !important;
      border-radius: 32px;
      box-shadow: none;
      text-shadow: none !important;
      &:hover {
        color: #3b9478;
        background: #fff;

        &::before {
          display: none;
        }
      }
    `};
`;

const Link = styled(Button)`
  text-decoration: none;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  margin: 0 auto;
`;

type Props = {
  to?: string,
  onClick?: () => void,
  type?: "trade" | "deposit",
  color?: "green" | "red" | "yellow",
  disabled?: boolean,
  isCardButton?: boolean,
  children: React.Node
};

const FlatButton = ({
  children,
  type,
  color,
  isCardButton,
  isTradePageCard,
  ...props
}: Props) => (
  <Link
    as={props.to != null ? _Link : Button}
    isCardButton={isCardButton}
    type={type}
    isTradePageCard={isTradePageCard}
    {...props}
  >
    {children}
  </Link>
);

export default FlatButton;



// WEBPACK FOOTER //
// ./src/components/Buttons/FlatButton.js